import React, { useEffect, useState } from "react";
import Index from "../../..";
import PagesIndex from "../../../PageIndex";
import { SwipeableDrawer } from "@mui/material";
import DataService, {
  ADMIN_IMAGE_ENDPOINT,
} from "../../../../config/DataService";
import AddNewClient from "./client-manage-modal/AddNewClient";
import EditNewClient from "./client-manage-modal/EditNewClient";
import { getClientList } from "../../../../redux-toolkit/slice/admin-slice/AdminServices";
import ClientDeleteModel from "../client/client-manage-modal/ClientDeleteModal";
import AdminClientRestrict from "./client-manage-modal/AdminClientRestrict";
import Loader from "../../../../common/loader/Loader";
import { useNavigate } from "react-router-dom";

function ClientManage(props) {
  const [isActive, setActive] = useState(Array(0).fill(false));
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  // Pagination states and methods
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  // const toggleMenuClass = (event, index) => {
  //   setActive(!isActive);
  // };

  //Getting data from redux
  const { adminLoginData } = PagesIndex.useSelector(
    (state) => state.AdminSlice
  );
  const SubAdminPermission = adminLoginData?.roleId?.SubAdminPermission;
  // const roleName = adminLoginData?.name;
  const roleName = adminLoginData?.roleId?.Permission_name;

  const toggleMenuClass = (index) => {
    const updatedStates = [...isActive];
    updatedStates[index] = !updatedStates[index];
    setActive(updatedStates);
  };

  const dispatch = PagesIndex.useDispatch();

  // add user modal
  const [open, setOpen] = useState(false);
  const [userListData, setUserListData] = useState(false);
  const [editUserData, setEditUserData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  console.log(filteredData, "filteredData");

  // Add user Modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEditUserData("");
  };
  // Edit User Details modal
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const handleEditOpen = () => {
    setOpenEditModal(true);
  };
  const handleCloseEdit = () => setOpenEditModal(false);

  // Restrict modal
  const [restrictUserStatus, setRestrictUserStatus] = useState(false);
  const [restrictUserModalopen, setRestrictUserModalOpen] = useState(false);
  const restrictUserhandleOpen = (userId, status) => {
    const data = {
      userId: userId,
      status: !status,
    };
    setRestrictUserModalOpen(true);
    setRestrictUserStatus(data);
  };
  const restrictUserhandleClose = () => {
    setRestrictUserModalOpen(false);
  };

  // Delete functionality
  const [deleteUserId, setDeleteUserId] = useState([]);
  const [openDeleteNew, setOpenDeleteNew] = useState(false);
  const handleOpenDeleteNew = () => setOpenDeleteNew(true);
  const handleCloseDeleteNew = () => setOpenDeleteNew(false);

  // filter
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  // get user list
  const getUserListData = () => {
    setLoading(true);
    dispatch(getClientList()).then((res) => {
      if (res?.payload?.status == 200) {
        setUserListData(res?.payload?.data);
        setFilteredData(res?.payload?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  PagesIndex.useEffect(() => {
    getUserListData();
  }, []);

  // Search on table
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    const filteredList = userListData?.filter((data) =>
      `${data.name.toLowerCase()} ${data.mobileNumber
        }  ${data.email.toLowerCase()}`.includes(e.target.value.toLowerCase())
    );
    setFilteredData(filteredList);
  };

  // US Formate
  const formatPhoneNumber = (input) => {
    // Remove all non-digit characters from the input
    const cleaned = ("" + input).replace(/\D/g, "");

    // Format the cleaned phone number
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return cleaned;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Index.Box>
          <Index.Box className="user-list-flex">
            <Index.Typography
              className="admin-page-title user-list-page-title"
              component="h2"
              variant="h2"
            >
              {/* <Index.Link to="/admin/dashboard" className="filter-back-link">
                <img
                  src={PagesIndex.Svg.leftArrow}
                  className="left-arrow-ic"
                  alt="search grey img"
                ></img>
              </Index.Link>{" "} */}
              Vendor Management
            </Index.Typography>

            {/* Top search */}
            <Index.Box className="userlist-btn-flex">
              <Index.Box className="user-search-main">
                <Index.Box className="user-search-box">
                  <Index.Box className="form-group">
                    <Index.TextField
                      fullWidth
                      id="fullWidth"
                      className="form-control"
                      placeholder="Search"
                      value={searchValue}
                      onChange={handleSearch}
                      onKeyDown={(e) => {
                        if (e.key === " " && e.target.value.trim() === "") {
                          e.preventDefault();
                        }
                      }}
                    />
                    <img
                      src={PagesIndex.Svg.search}
                      className="search-grey-img"
                      alt="search grey img"
                    ></img>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              {/* top Filter */}
              {/* <Index.Box className="filter-main">
                {["right"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    <Index.Box className="export-btn-main border-btn-main">
                      <Index.Button
                        className="export-btn border-btn"
                        onClick={toggleDrawer(anchor, true)}
                      >
                        <img
                          src={PagesIndex.Svg.filter}
                          className="down-icon"
                          alt="download icon"
                        />
                        Filter
                      </Index.Button>
                    </Index.Box>
                    <SwipeableDrawer
                      className="filter-main"
                      anchor={anchor}
                      open={state[anchor]}
                      onClose={toggleDrawer(anchor, false)}
                      onOpen={toggleDrawer(anchor, true)}
                    >
                      <Index.Box className="filter-header">
                        <Index.Typography className="filter-title">
                          User Filter
                        </Index.Typography>
                        <img
                          src={PagesIndex.Svg.closeicon}
                          className="filter-close-icon"
                          onClick={toggleDrawer(anchor, false)}
                          alt=""
                        />
                      </Index.Box>
                      <Index.Box className="filter-inner-main">
                        <Index.Box className="input-box filter-input-box">
                          <Index.FormHelperText className="form-lable">
                            Name
                          </Index.FormHelperText>
                          <Index.Box className="form-group">
                            <Index.TextField
                              fullWidth
                              id="fullWidth"
                              className="form-control"
                              placeholder=""
                            />
                          </Index.Box>
                        </Index.Box>
                        <Index.Box className="input-box filter-input-box">
                          <Index.FormHelperText className="form-lable">
                            City
                          </Index.FormHelperText>
                          <Index.Box className="form-group">
                            <Index.TextField
                              fullWidth
                              id="fullWidth"
                              className="form-control"
                              placeholder=""
                            />
                          </Index.Box>
                        </Index.Box>
                        <Index.Box className="input-box filter-input-box">
                          <Index.FormHelperText className="form-lable">
                            Status
                          </Index.FormHelperText>
                          <Index.Box className="checkbox-main filter-checkbox-main input-box">
                            <Index.FormControlLabel
                              control={<Index.Checkbox defaultChecked />}
                              label="Active"
                              className="checkbox-lable"
                            />
                            <Index.FormControlLabel
                              control={<Index.Checkbox />}
                              label="Deactivate"
                              className="checkbox-lable"
                            />
                            <Index.FormControlLabel
                              control={<Index.Checkbox />}
                              label="Pending"
                              className="checkbox-lable"
                            />
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                      <Index.Box className="filter-footer">
                        <Index.Box className="filter-btn-main border-btn-main btn-main-primary">
                          <Index.Button className="border-btn filter-cancel-btn">
                            Cancel
                          </Index.Button>
                          <Index.Button className="btn-primary filter-btn">
                            Filter
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </SwipeableDrawer>
                  </React.Fragment>
                ))}
              </Index.Box> */}
              {/* Add user Button */}
              <Index.Box className="userlist-inner-btn-flex">
                <Index.Box className="adduser-btn-main btn-main-primary">
                  {roleName === "Admin" ||
                    SubAdminPermission?.Client?.permission?.add == true ? (
                    <Index.Button
                      className="adduser-btn btn-primary"
                      onClick={() => {
                        handleOpen();
                      }}
                    >
                      <img
                        src={PagesIndex.Svg.plus}
                        className="plus-icon"
                        alt="plus icon"
                      />
                      Add Vendor
                    </Index.Button>
                  ) : null}
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>

          {/* Edit User Details End */}
          <Index.Box className="client-manage-sec">
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <Index.Box className="card-main">
                  <Index.Box className="card-left">
                    <Index.Box className="officer-profile-flex">
                      <img
                        src={
                          item?.image
                            ? // ? `${ADMIN_IMAGE_ENDPOINT}${item?.image}`
                            `${PagesIndex.ADMIN_IMAGE_ENDPOINT}/${item?.image}`
                            : PagesIndex.Png.usericon
                        }
                        alt=""
                        className="prof-img"
                      />
                      <Index.Box className="officer-detail">
                        <Index.Typography
                          component="p"
                          variant="p"
                          className="officer-detail-title"
                        >
                          {item?.name}
                        </Index.Typography>

                        <Index.Typography
                          component="p"
                          variant="p"
                          className="officer-detail-email"
                        >
                          {item?.email}
                        </Index.Typography>
                        <Index.Typography
                          component="p"
                          variant="p"
                          className="officer-detail-numebr"
                        >
                          {formatPhoneNumber(item?.mobileNumber)}
                        </Index.Typography>
                        <Index.Typography
                          component="p"
                          variant="p"
                          className="suspend_label"
                        >
                          {!item?.isApprove && "Restricted"}
                        </Index.Typography>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="card-right btn-main-secondary btn-main-red btn-main-orange btn-main-yellow">
                    <Index.Link
                      to=""
                      onClick={() => toggleMenuClass(index)}
                      className="more-btn"
                    >
                      <img src={PagesIndex.Svg.dotmenu} alt="" />
                    </Index.Link>
                    <Index.Box
                      id="btn-toggle-popup"
                      className={isActive[index] ? "toggle-pop-show" : null}
                    >
                      {roleName === "Admin" ||
                        SubAdminPermission?.Client?.permission?.read == true ? (
                        <Index.Tooltip
                          title="View Job History"
                          arrow
                          placement="bottom"
                          className="admin-tooltip"
                        >
                          <Index.Link
                            to={`/admin/vendormanage/vendorhistory/${item._id}`}
                          >
                            <Index.Button
                              btnLabel="View Job History"
                              className="btn-orange"
                            >
                              <img
                                src={PagesIndex.Svg.eyeIcon}
                                alt="delete"
                                className="admin-icons"
                              />
                            </Index.Button>
                          </Index.Link>
                        </Index.Tooltip>
                      ) : null}
                      {roleName === "Admin" ||
                        SubAdminPermission?.Client?.permission?.Suspend ==
                        true ? (
                        <>
                          {item?.isApprove == true ? (
                            <>
                              <Index.Tooltip
                                title="Restrict"
                                arrow
                                placement="bottom"
                                className="admin-tooltip"
                              >
                                <Index.Button
                                  onClick={() =>
                                    restrictUserhandleOpen(
                                      item?._id,
                                      item?.isApprove
                                    )
                                  }
                                  btnLabel={
                                    item?.isApprove ? "Activate" : "Restrict"
                                  }
                                  className={
                                    item?.isApprove
                                      ? "btn-red bg-active"
                                      : "btn-red btn-green bg-suspend"
                                  }
                                >
                                  <img
                                    src={PagesIndex.Svg.prohibitionIcon}
                                    alt="delete"
                                    className="admin-icons"
                                  />
                                </Index.Button>
                              </Index.Tooltip>
                            </>
                          ) : (
                            <>
                              <Index.Tooltip
                                title="Active"
                                arrow
                                placement="bottom"
                                className="admin-tooltip"
                              >
                                <Index.Button
                                  onClick={() =>
                                    restrictUserhandleOpen(
                                      item?._id,
                                      item?.isApprove
                                    )
                                  }
                                  btnLabel={
                                    item?.isApprove ? "Activate" : "Restrict"
                                  }
                                  className={
                                    item?.isApprove
                                      ? "btn-red bg-active"
                                      : "btn-red btn-green bg-suspend"
                                  }
                                >
                                  <img
                                    src={PagesIndex.Svg.activeCheck}
                                    alt="delete"
                                    className="admin-icons"
                                  />
                                </Index.Button>
                              </Index.Tooltip>
                            </>
                          )}
                        </>
                      ) : null}

                      {/* <Index.Link to="/admin/userhistory"> */}

                      {/* </Index.Link> */}
                      {roleName === "Admin" ||
                        SubAdminPermission?.Client?.permission?.edit == true ? (
                        <Index.Tooltip
                          title="Edit"
                          arrow
                          placement="bottom"
                          className="admin-tooltip"
                        >
                          <Index.Button
                            btnLabel="Edit"
                            className="btn-secondary"
                            onClick={() => {
                              // handleEditOpen();
                              handleOpen();
                              setEditUserData(item);
                            }}
                          >
                            <img
                              src={PagesIndex.Svg.editNew}
                              alt="delete"
                              className="admin-icons"
                            />
                          </Index.Button>
                        </Index.Tooltip>
                      ) : null}

                      {roleName === "Admin" ||
                        SubAdminPermission?.Client?.permission?.delete == true ? (
                        <Index.Tooltip
                          title="Delete"
                          arrow
                          placement="bottom"
                          className="admin-tooltip"
                        >
                          <Index.Button
                            btnLabel="delete"
                            className="btn-red"
                            onClick={() => {
                              handleOpenDeleteNew();
                              setDeleteUserId(item?._id);
                            }}
                          >
                            <img
                              src={PagesIndex.Svg.deletewhite}
                              alt="delete"
                              className="admin-icons"
                            />
                          </Index.Button>
                        </Index.Tooltip>
                      ) : null}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              ))
            ) : (
              <PagesIndex.NoDataFound />
            )}
          </Index.Box>
        </Index.Box>
      )}

      {/* Add New User modal */}

      <AddNewClient
        getUserListData={getUserListData}
        handleClose={handleClose}
        open={open}
        editUserData={editUserData}
      />

      {/* End Add New User */}
      {/* Edit User Details start */}
      <EditNewClient
        getUserListData={getUserListData}
        handleCloseEdit={handleCloseEdit}
        openEditModal={openEditModal}
        editUserData={editUserData}
      />

      {/* Restrict User modal */}
      <AdminClientRestrict
        restrictUserModalopen={restrictUserModalopen}
        restrictUserhandleClose={restrictUserhandleClose}
        restrictUserStatus={restrictUserStatus}
        getUserListData={getUserListData}
      />
      {/* delete modal */}
      <ClientDeleteModel
        handleCloseDeleteNew={handleCloseDeleteNew}
        openDeleteNew={openDeleteNew}
        getUserListData={getUserListData}
        deleteUserId={deleteUserId}
      />
    </>
  );
}

export default ClientManage;
